import React from 'react';
import { useSelector } from 'react-redux';
import { DialogDecorated, DialogBody, DialogTitle } from 'components/redux-dialog';

import { getVideoSelector, getUITVideoisDownloadableSelector } from 'components/video-box/selectors';
import { websiteSelector } from 'common/selectors/website';

export const UIT_VIDEO_DOWNLOAD_DIALOG = 'uitVideoDownloadDialog';

const getFileName = (status) => {
  switch (status) {
    case 1:
      return '/technisches/webforms-formular.html';
    case 2:
      return '/technisches/video-anfordern-berater.html';
    default:
      return '/technisches/webforms-formular.html';
  }
};

const getLink = (website, video) => {
  const uitTestWebsiteId = '43';
  const fileName = getFileName(video.uitVideoDownloadableStatus);
  const videoTitle = encodeURIComponent(video.title);
  const videoId = encodeURIComponent(video.id);

  const hostName =
    `${website.id}` === uitTestWebsiteId
      ? 'https://portal-abnahme.union-investment.de'
      : 'https://portal.union-investment.de';
  const path = '/o/lr-connector-content';
  const params = `?filename=${fileName}&title=${videoTitle}&videoId=${videoId}`;

  return `${hostName}${path}${params}`;
};

export const UitDownloadVideoDialog = () => {
  const video = useSelector(getVideoSelector);
  const website = useSelector(websiteSelector);
  const isDownloadable = useSelector(getUITVideoisDownloadableSelector);

  if (!isDownloadable) {
    return false;
  }

  return (
    <DialogDecorated className="uit-download-video-dialog" dialogName={UIT_VIDEO_DOWNLOAD_DIALOG}>
      <DialogTitle />
      <DialogBody>
        <iframe
          title="Download video"
          frameBorder="0"
          className="uit-download-video-dialog__iframe"
          src={getLink(website, video)}
        />
      </DialogBody>
    </DialogDecorated>
  );
};
